import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { AI_INSIGHT_FEEDBACK_KEY } from './constants';

type AIInsightAgentType =
    | 'care_manager_digest'
    | 'call_purpose'
    | 'patient_context'
    | 'recommendations';

type AIInsightFeedbackPayload = {
    call_id: string;
    agent_type: AIInsightAgentType;
    rating?: 'up' | 'down' | null;
    comment?: string | null;
};

const useSubmitAIInsightFeedback = () => {
    const req = useRequest();

    const request = useCallback(
        ({ payload }: { payload: AIInsightFeedbackPayload }) => {
            return req<void>({
                url: `${envVars.API_AI_HOSTNAME}care-manager-digest/feedback`,
                method: 'POST',
                body: payload
            });
        },
        [req]
    );

    return useMutation({
        mutationFn: request,
        mutationKey: [AI_INSIGHT_FEEDBACK_KEY]
    });
};

export default useSubmitAIInsightFeedback;
